export default "__VITE_ASSET__A3vPgNbZ__"